import Vue from 'vue';
import moment from 'moment';
import { Utils } from '@/assets/js/utils';

// timestampTZ -> date (년-월-일)
Vue.filter('timestampFilter', (value) => {
    if (value === null || value === '' || value === undefined) {
        return value;
    }

    function addZero(target) {
        // 9 이하의 숫자는 0 붙이기
        const num = parseInt(target);
        const str = num > 9 ? num : `0${num}`;
        return str.toString();
    }

    const b = value.split(/\D/);
    --b[1];
    b[6] = b[6].substr(0, 3);
    const d = new Date(Date.UTC(...b));
    return `${d.getFullYear()}-${addZero(d.getMonth() + 1)}-${addZero(d.getDate())}`;
});

// timestampTZ -> date (년-월-일 시:분:초)
Vue.filter('timestampFilter2', (value) => {
    if (value === null || value === '' || value === undefined) {
        return value;
    }

    if (value == "-") {
        return value;
    }

    function addZero(target) {
        // 9 이하의 숫자는 0 붙이기
        const num = parseInt(target);
        const str = num > 9 ? num : `0${num}`;
        return str.toString();
    }

    const b = value.split(/\D/);
    --b[1];
    b[6] = b[6].substr(0, 3);
    const d = new Date(Date.UTC(...b));
    return `${d.getFullYear()}-${addZero(d.getMonth() + 1)}-${addZero(d.getDate())} ${addZero(d.getHours())}:${addZero(
        d.getMinutes()
    )}:${addZero(d.getSeconds())}`;
});

// timestampTZ -> date (년-월-일 시:분)
Vue.filter('timestampFilter3', (value) => {
    if (value === null || value === '' || value === undefined) {
        return value;
    }

    function addZero(target) {
        // 9 이하의 숫자는 0 붙이기
        const num = parseInt(target);
        const str = num > 9 ? num : `0${num}`;
        return str.toString();
    }

    const b = value.split(/\D/);
    --b[1];
    b[6] = b[6].substr(0, 3);
    const d = new Date(Date.UTC(...b));
    return `${d.getFullYear()}-${addZero(d.getMonth() + 1)}-${addZero(d.getDate())} ${addZero(d.getHours())}:${addZero(
        d.getMinutes()
    )}`;
});

// timestampTZ -> date (년. 월 .일)
Vue.filter('timestampFilter4', (value) => {
    if (value === null || value === '' || value === undefined) {
        return value;
    }

    function addZero(target) {
        // 9 이하의 숫자는 0 붙이기
        const num = parseInt(target);
        const str = num > 9 ? num : `0${num}`;
        return str.toString();
    }

    const b = value.split(/\D/);
    --b[1];
    b[6] = b[6].substr(0, 3);
    const d = new Date(Date.UTC(...b));

    return `${d.getFullYear()}. ${addZero(d.getMonth() + 1)}. ${addZero(d.getDate())}`;
});

// timestampTZ -> date (년.월.일)(요일)
Vue.filter('timestampFilter5', (value) => {
    if (value === null || value === '' || value === undefined) {
        return value;
    }

    function addZero(target) {
        // 9 이하의 숫자는 0 붙이기
        const num = parseInt(target);
        const str = num > 9 ? num : `0${num}`;
        return str.toString();
    }

    const b = value.split(/\D/);
    --b[1];
    b[6] = b[6].substr(0, 3);
    const d = new Date(Date.UTC(...b));

    const date1 = `${d.getFullYear()}-${addZero(d.getMonth() + 1)}-${addZero(d.getDate())}`;
    const date2 = `${d.getFullYear()}.${addZero(d.getMonth() + 1)}.${addZero(d.getDate())}`;

    return `${date2}(${Utils.getDayOfWeekName(date1)})`;
});

// 전화번호 필터
Vue.filter('phoneNumberFilter', (phoneNumber) => {
    if (!phoneNumber) return phoneNumber;

    phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

    let tmp = '';
    if (phoneNumber.length < 4) {
        return phoneNumber;
    } else if (phoneNumber.length < 7) {
        tmp += phoneNumber.substr(0, 3);
        tmp += '-';
        tmp += phoneNumber.substr(3);
        return tmp;
    } else if (phoneNumber.length == 8) {
        tmp += phoneNumber.substr(0, 4);
        tmp += '-';
        tmp += phoneNumber.substr(4);
        return tmp;
    } else if (phoneNumber.length == 9) {
        if (phoneNumber.substr(0, 2) == '02') {
            // 02-123-5678
            tmp += phoneNumber.substr(0, 2);
            tmp += '-';
            tmp += phoneNumber.substr(2, 3);
            tmp += '-';
            tmp += phoneNumber.substr(5);
            return tmp;
        }
    } else if (phoneNumber.length == 10) {
        if (phoneNumber.substr(0, 2) == '02') {
            // 02-1234-5678
            tmp += phoneNumber.substr(0, 2);
            tmp += '-';
            tmp += phoneNumber.substr(2, 4);
            tmp += '-';
            tmp += phoneNumber.substr(6);
            return tmp;
        } else {
            // 010-123-4567
            tmp += phoneNumber.substr(0, 3);
            tmp += '-';
            tmp += phoneNumber.substr(3, 3);
            tmp += '-';
            tmp += phoneNumber.substr(6);
            return tmp;
        }
    }
    // 010-1234-5678
    tmp += phoneNumber.substr(0, 3);
    tmp += '-';
    tmp += phoneNumber.substr(3, 4);
    tmp += '-';
    tmp += phoneNumber.substr(7);
    return tmp;

});

// 전화번호 보안 필터
Vue.filter('phoneNumberSecurityFilter', (phoneNumber) => {
    if (!phoneNumber) return phoneNumber;

    phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

    let tmp = '';
    if (phoneNumber.length < 4) {
        return phoneNumber;
    } else if (phoneNumber.length < 7) {
        tmp += phoneNumber.substr(0, 3);
        tmp += '-';
        tmp += phoneNumber.substr(3);
        return tmp;
    } else if (phoneNumber.length == 8) {
        tmp += phoneNumber.substr(0, 4);
        tmp += '-';
        tmp += phoneNumber.substr(4);
        return tmp;
    } else if (phoneNumber.length < 10) {
        if (phoneNumber.substr(0, 2) == '02') {
            // 02-123-5678
            tmp += phoneNumber.substr(0, 2);
            tmp += '-';
            tmp += '***';
            tmp += '-';
            tmp += phoneNumber.substr(5);
            return tmp;
        }
    } else if (phoneNumber.length < 11) {
        if (phoneNumber.substr(0, 2) == '02') {
            // 02-1234-5678
            tmp += phoneNumber.substr(0, 2);
            tmp += '-';
            tmp += '****';
            tmp += '-';
            tmp += phoneNumber.substr(6);
            return tmp;
        }
        // 010-123-4567
        tmp += phoneNumber.substr(0, 3);
        tmp += '-';
        tmp += '***';
        tmp += '-';
        tmp += phoneNumber.substr(6);
        return tmp;
    } else {
        // 010-1234-5678
        tmp += phoneNumber.substr(0, 3);
        tmp += '-';
        tmp += '****';
        tmp += '-';
        tmp += phoneNumber.substr(7);
        return tmp;
    }
});

Vue.filter('numberFormatFilter', (number) => {
    if (number === null || number === '' || number === undefined) {
        return number;
    }

    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});

Vue.filter('cardNumberFilter', (number) => {
    if (number === null || number === '' || number === undefined) {
        return number;
    }

    const str = String(number)
    return `${str.slice(0, 4)}-${str.slice(4, 8)}-${str.slice(8, 12)}-${str.slice(12, 16)}`
});

Vue.filter('formatDate', (value, format) => moment(value).locale('ko').format(format));

// 날짜 필터 yyyymmdd -> yyyy-mm-dd
Vue.filter(
    'dateFormatFilter',
    (date) => {
        if(date === null || date === '' || date === undefined){
            return date || '';
        }

        if(moment(date).isValid()) return moment(date).format('YYYY-MM-DD');

        return date.slice(0, 8).replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
    }
);

// 날자 필터 yyyymmdd -> yyyy-mm-dd
Vue.filter(
    'dateFormatFilter2',
    (date) => {
        if(date === null || date === '' || date === undefined){
            return date || '';
        }

        if(moment(date).isValid()) return moment(date).format('YYYY\\년 MM\\월 DD\\일');

        return date.slice(0, 8).replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
    }
);

// 수업관리 날짜 자르기 UTC
Vue.filter('dateSplitFilter', (value) => {
    const date = value.split('T');
    return date[0];
});

// UTC 날짜 필터
Vue.filter(
    'utcToYMDHmFilter',
    (value) => moment(value).format('YYYY-MM-DD HH:mm')
    /*
	const date = value.split("T");
	const time = date[1].split(":");
	return `${date[0]} ${parseInt(time[0]) + 9}:${time[0]}`; //UTC + 9 => KST
	 */
);

//
Vue.filter('timeCutter', (value) => {
    if (value === null || value === '' || value === undefined) {
        return value;
    }
    const date = value.substr(0, 5);
    return date;
});

//
Vue.filter('formatHourMinutes', (value) => {
    if (value === null || value === '' || value === undefined) {
        return value;
    }
    let dates = value.split('T');
    if (dates.length === 0) {
        dates = value.split(' ');
    }

    const times = dates.length === 1 ? dates[0] : dates[1];

    const arr = times.split(':');

    return `${arr[0]}:${arr[1]}`;
});

Vue.filter('formatConvertUTC', (value) =>
    // 'MM-DD hh:mm' moment 사용
    moment(value).format('MM.DD HH:mm')
);

Vue.filter('formatConvertUTCTime', (value) =>
    // 'MM-DD hh:mm' moment 사용
    moment(value).format('HH:mm')
);

Vue.filter('getContractMemberType', (type) => {
    if (type == 'P') {
        return "직원";
    } else if (type == 'M') {
        return "회원";
    } else if (type == 'E') {
        return "기타";
    }
});
Vue.filter('getContractMemberType2', (type) => {
    if (type == 'P') {
        return "센터";
    } else if (type == 'M') {
        return "회원";
    } else if (type == 'E') {
        return "기타";
    }
});

Vue.filter('getContractHistoryStatus', (type) => {
    if (type == 'I') {
        return "등록";
    } else if (type == 'D') {
        return "수정";
    } else if (type == 'A') {
        return "항목 추가";
    } else if (type == 'E') {
        return "항목 수정";
    } else if (type == 'C') {
        return "서명 수정";
    } else if (type == 'R') {
        return "서명 등록";
    }
});

Vue.filter('getContractSendStatus', (type) => {
    if (type == 'S') {              // 서명요청
        return "서명요청";
    } else if (type == 'C') {       // 서명취소
        return "발송취소";
    } else if (type == 'R') {       // 계약완료
        return "계약완료";
    } else if (type == 'P') {       // 기간완료
        return "기간완료";
    } else if (type == 'N') {       // 계약취소
        return "서명취소";
    } else {
        return type;
    }
});

Vue.filter('getNotiTalkType', (type) => {
    if (type == 1) {
        return "계약서 발송";
    } else if (type == 2) {
        return "발송 취소";
    } else if (type == 3) {
        return "발송 취소";
    } else if (type == 4) {
        return "계약완료(대표자)";
    } else if (type == 5) {
        return "계약완료(수신인)";
    } else {
        return type;
    }
});

Vue.filter('getContractSendStatusStr', (type) => {
    if (type == 'S') {              // 서명요청
        return "서명요청된 계약서입니다.";
    } else if (type == 'C') {       // 서명취소
        return "발송취소된 계약서입니다.";
    } else if (type == 'R') {       // 계약완료
        return "서명된 계약서입니다.";
    } else if (type == 'P') {       // 기간완료
        return "기간만료된 계약서입니다.";
    } else if (type == 'N') {       // 계약취소
        return "취소된 계약서입니다.";
    } else {
        return type;
    }
});

Vue.filter('getContractResultTitleStatusStr', (type) => {
    if (type === 'S') {              // 서명요청
        return "계약이 서명요청되었습니다.";
    } else if (type === 'C') {       // 서명취소
        return "계약이 발송취소되었습니다.";
    } else if (type === 'R') {       // 계약완료
        return "계약이 완료되었습니다.";
    } else if (type === 'P') {       // 기간완료
        return "계약이 기간만료되었습니다";
    } else if (type === 'N') {       // 계약취소
        return "계약이 취소되었습니다.";
    } else {
        return type;
    }
});
Vue.filter('getContractResultContentStatusStr', (type) => {
    if (type === 'S') {              // 서명요청
        return "서명요청된 문서";
    } else if (type === 'C') {       // 서명취소
        return "취소된 문서";
    } else if (type === 'R') {       // 계약완료
        return "완료된 문서";
    } else if (type === 'P') {       // 기간완료
        return "기간만료된 문서";
    } else if (type === 'N') {       // 계약취소
        return "취소된 문서";
    } else {
        return type;
    }
});

Vue.filter('getContractStatus', (type) => {
    if (type === 'S') {              // 서명요청
        return "서명요청";
    } else if (type === 'C') {       // 서명취소
        return "서명취소";
    } else if (type === 'R') {       // 계약완료
        return "계약완료";
    } else if (type === 'P') {       // 기간완료
        return "기간만료";
    } else if (type === 'N') {       // 계약취소
        return "계약취소";
    } else if (type === 'D') {       // 기한연장
        return "기한연장";
    } else {
        return type;
    }
});

Vue.filter('getContractSendType', (type) => {
    if (type === 1) {              // 서명요청
        return "카카오톡 서명";
    } else if (type === 2) {       // 서명취소
        return "직접 서명";
    } else {
        return type;
    }
});

Vue.filter('formatTicketType', (type) => {
    if (type === 'P') {
        return '개인';
    } else if (type === 'O') {
        return 'OT';
    } else if (type === 'D') {
        return '듀엣';
    } else if (type === 'G') {
        return '그룹';
    } else if (type === 'C') {
        return '쿠폰';
    } else if (type === 'T') {
        return '회원권';
    } else if (type === 'S') {
        return '운동복';
    }
});
